import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  sidebarOpen: true,
  theme: 'light',
  notifications: [],
  loading: {
    global: false,
    actions: {},
  },
  dialogs: {
    confirmDialog: {
      open: false,
      title: '',
      message: '',
      onConfirm: null,
    },
  },
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleSidebar: (state) => {
      state.sidebarOpen = !state.sidebarOpen;
    },
    setSidebarOpen: (state, action) => {
      state.sidebarOpen = action.payload;
    },
    setTheme: (state, action) => {
      state.theme = action.payload;
    },
    setGlobalLoading: (state, action) => {
      state.loading.global = action.payload;
    },
    setActionLoading: (state, action) => {
      const { action: actionName, loading } = action.payload;
      state.loading.actions[actionName] = loading;
    },
    addNotification: (state, action) => {
      state.notifications.push({
        id: Date.now(),
        ...action.payload,
        timestamp: new Date().toISOString(),
      });
    },
    removeNotification: (state, action) => {
      state.notifications = state.notifications.filter(
        notification => notification.id !== action.payload
      );
    },
    clearNotifications: (state) => {
      state.notifications = [];
    },
    openConfirmDialog: (state, action) => {
      state.dialogs.confirmDialog = {
        open: true,
        ...action.payload,
      };
    },
    closeConfirmDialog: (state) => {
      state.dialogs.confirmDialog = {
        open: false,
        title: '',
        message: '',
        onConfirm: null,
      };
    },
  },
});

export const {
  toggleSidebar,
  setSidebarOpen,
  setTheme,
  setGlobalLoading,
  setActionLoading,
  addNotification,
  removeNotification,
  clearNotifications,
  openConfirmDialog,
  closeConfirmDialog,
} = uiSlice.actions;

export default uiSlice.reducer;
